'use client'

import { buildWatermarkUrl } from '@/lib/watermarkLink'
import { FC } from 'react'
import { CREDIT_STRIP_HEIGHT } from './boxConstants'

/**
 * BOX型の moovy studio クレジット。
 * `overlay` を立てると動画の下端へ重ねる（PCは映像を最大化するため帯を作らない）。
 */
const BoxWatermark: FC<{ overlay?: boolean }> = ({ overlay = false }) => (
  <a
    href={buildWatermarkUrl('embed_modal')}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Powered by moovy studio"
    style={{
      position: overlay ? 'absolute' : 'relative',
      right: overlay ? 0 : undefined,
      bottom: overlay ? 0 : undefined,
      left: overlay ? 0 : undefined,
      zIndex: overlay ? 35 : undefined,
      display: 'flex',
      height: `${CREDIT_STRIP_HEIGHT}px`,
      flexShrink: 0,
      alignItems: 'center',
      justifyContent: 'center',
      gap: '6px',
      color: 'rgba(255,255,255,0.8)',
      fontSize: '11px',
      textDecoration: 'none',
      textShadow: overlay ? '0 1px 12px rgba(0,0,0,0.8)' : undefined,
    }}
  >
    <span>Powered by</span>
    {/* eslint-disable-next-line @next/next/no-img-element */}
    <img
      src="https://studio.moovy.jp/images/logo-moovystudio-white.png"
      alt="moovy studio"
      width={84}
      height={14}
      style={{ height: '14px', width: 'auto', filter: overlay ? 'drop-shadow(0 1px 12px rgba(0,0,0,0.8))' : undefined }}
    />
  </a>
)

export default BoxWatermark
